import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
} from '@mui/material';

const DocumentManagement: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ width: '100%', mb: 2, p: 3 }}>
        <Typography variant="h6" gutterBottom>
          문서 관리
        </Typography>
        <Box>
          {/* 문서 관리 기능이 추가될 예정입니다 */}
          <Typography variant="body1" color="text.secondary">
            문서 관리 기능이 준비 중입니다.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default DocumentManagement; 